var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"pc-placard-modal",attrs:{"visible":_vm.dialogData.isShow,"close-on-click-modal":false},on:{"update:visible":function($event){return _vm.$set(_vm.dialogData, "isShow", $event)}}},[(_vm.websiteInfo.id)?_c('sub-placard',{attrs:{"userName":_vm.userName,"configData":_vm.websiteInfo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }